export default "__VITE_ASSET__GOfNKA0j__"